import { atom, getDefaultStore, useAtomValue } from 'jotai';

type BootstrapStatus = 'idle' | 'loading-idb-cache' | 'loading-remote' | 'catch-up-remote';

const bootstrapStatusAtom = atom<BootstrapStatus>('idle');

export const useBootstrapStatus = (): BootstrapStatus => useAtomValue(bootstrapStatusAtom);
export const setBootstrapStatus = (newStatus: BootstrapStatus): void => getDefaultStore().set(bootstrapStatusAtom, newStatus);
